<mat-option [ngClass]="{ hide: !visible, show: visible }" [value]="value">
  <ng-content></ng-content>
</mat-option>
